import { showHttpError } from '@calendly/alert'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { createExport } from './api'

const initialState = { confirmationOpen: false }

const slice = createSlice({
  name: 'eventInviteesExport',
  initialState,
  reducers: {
    openConfirmation(state) {
      state.confirmationOpen = true
    },
    closeConfirmation(state) {
      state.confirmationOpen = false
    },
  },
})

export const createDelayedExport = createAsyncThunk(
  'event_invitees/export',
  async (params = {}, { dispatch, rejectWithValue }) => {
    const [success, response] = await createExport(params.eventId)

    if (success && response.location === 'inline' && !!response.url) {
      window.open(response.url, '_self')
      return rejectWithValue()
    }

    if (success) {
      return dispatch(slice.actions.openConfirmation())
    }

    return dispatch(showHttpError(response))
  }
)

export const confirmationOpenSelector = (state) => state.eventInviteesExport.confirmationOpen

export const { closeConfirmation } = slice.actions
export const reducer = slice.reducer
